module.exports = __webpack_public_path__ + "img/character-fish-sad.6583c9c9.svg";